import { Buffer } from 'buffer';
import { isProductionHost } from './host';

export const mightBeLoggedIn = (req) =>
    Boolean(req.cookies[getRefreshTokenCookieName(req)]) ||
    getMemberIdFromAuthCookie(req);

export const getAccessTokenCookieDomain = (req) => {
    if (isProductionHost(req.headers.host)) {
        return '.tradera.com';
    }
    return req.headers['host'].split(':')[0];
};

export const getRefreshTokenCookieDomain = () => undefined;

export const getAccessTokenCookieName = (req) =>
    isProductionHost(req.headers.host) ? 'trd_at' : 'trd_at_test';

export const getRefreshTokenCookieName = (req) =>
    isProductionHost(req.headers.host) ? 'trd_rt' : 'trd_rt_test';

export const getPersistTokenCookieName = (req) =>
    isProductionHost(req.headers.host) ? 'trd_rk' : 'trd_rk_test';

export const getMemberIdFromAuthCookie = (req) =>
    getJwtPayload(req.cookies?.[getAccessTokenCookieName(req)])?.mbr;

export const getExpiryFromAuthCookie = (req) =>
    getJwtPayload(req.cookies?.[getAccessTokenCookieName(req)])?.exp;

const getJwtPayload = (jwtToken) => {
    const [, payload] = (jwtToken || '').split('.');
    if (!payload) {
        return {};
    }
    try {
        return JSON.parse(Buffer.from(payload, 'base64').toString());
    } catch (error) {
        return {};
    }
};

export const isTokenExpiringSoon = (token) => {
    const { exp: expiry } = getJwtPayload(token);
    if (!expiry) {
        return true;
    }
    const now = new Date();
    const expiryDate = new Date(expiry);
    const expiresSoonDate = new Date(expiryDate.getTime() - 60 * 1000);
    const isExpired = expiresSoonDate <= now;
    return isExpired;
};

export const addCookie = (res, cookie) => {
    const previouslySetCookies = res.getHeader('Set-Cookie');
    if (Array.isArray(previouslySetCookies)) {
        res.setHeader('Set-Cookie', [...previouslySetCookies, cookie]);
    } else if (previouslySetCookies) {
        res.setHeader('Set-Cookie', [previouslySetCookies, cookie]);
    } else {
        res.setHeader('Set-Cookie', cookie);
    }
};
